<template>
	<div>
		<CreateEditUser :userId="id" />
	</div>
</template>

<script>
import CreateEditUser from './components/CreateEditUser';
export default {
	components: { CreateEditUser },
	data: () => ({
		id: null
	}),

	mounted() {
		this.id = this.$route.params.id;
	}
};
</script>
